import React, { useEffect, useState } from "react";
import StickyTitle from '../components/StickyTitle'
import ReactToPrint from "react-to-print";
import {
    InputLabel,
    FormControl,
    Button
} from "@mui/material";
import Select from "react-select";
import companylogo from "../../assets/company.png"

const PurchaseExpenseReportsPage = () => {

    const [fromDate, setFromDate] = useState("");
    const [Purchases, setPurchases] = useState();
    const [Expenses, setExpenses] = useState();
    const [filteredPurchases, setfilteredPurchases] = useState();
    const [filteredExpenses, setfilteredExpenses] = useState();
    const [toDate, setToDate] = useState("");
    const [option, setOption] = useState("purchase");
    const [category, setCategory] = useState(null)
    const [categoryData, setCategoryData] = useState(null)
    const [searchQuery, setSearchQuery] = useState(null)

    const componentRef = React.createRef();

    useEffect(() => {
        const fetch_expenses = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_BASE_URL}/expenses/all_expenses`);
                const responseData = await response.json();
                if (responseData) {
                    setExpenses(responseData.expense)
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        }
        const fetch_purchases = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_BASE_URL}/purchases/all_purchases`);
                const responseData = await response.json();
                if (responseData) {
                    setPurchases(responseData)
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        }

        // fetch category

        const fetchCategory = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_BASE_URL}/category/all_categories`);
                const responseData = await response.json();
                if (responseData) {
                    const temp = responseData.categories?.map((cat)=>
                        ({value:cat.id, label:`${cat.categoryname} ID: ${cat.id}`})
                    )
                    setCategoryData(temp)
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        }
        fetchCategory();

        fetch_expenses();
        fetch_purchases();
    }, []);


    useEffect(() => {
        let filteredData = Purchases;

        if (fromDate && toDate) {
            filteredData = filteredData.filter(purchase => purchase.purchase_date >= fromDate && purchase.purchase_date <= toDate);
        }

        if(category) {
            filteredData = filteredData.filter(item => item.categoryId == category.value);
        }

        setfilteredPurchases(filteredData);

    }, [Purchases, fromDate, toDate, category]);


    useEffect(() => {
        let filteredData = Expenses;

        if (fromDate && toDate) {
            filteredData = filteredData.filter(expense => expense.expensedate >= fromDate && expense.expensedate <= toDate);
        }

        // Apply search filter
        if (searchQuery) {
            filteredData = filteredData.filter(expense => {
                // Assuming you want to search in the 'description' field, replace it with the correct field if needed
                return expense.title.toLowerCase().includes(searchQuery.toLowerCase());
            });
        }

        setfilteredExpenses(filteredData);
    }, [Expenses, fromDate, toDate, searchQuery]);


    const handleToggle = (type) => {
        setOption(type);
        setFromDate("");
        setToDate("");
    };

    const calculateTotalPayments = (payments, type) => {
        if (type === "purchase") {
            return payments && payments?.reduce((total, payment) => total + parseInt(payment.total), 0);
        }
        else if (type === "expense") {
            return payments && payments?.reduce((total, payment) => total + parseInt(payment.amount), 0);
        }
    };

    return (
        <>
            <StickyTitle no_button={true} title="Purchase/Expense Reports" />
            <div className=' px-4 lg:px-16 py-4 lg:py-10 flex flex-col gap-0 overflow-x-auto'>

                <div className="w-full flex flex-row justify-center items-center">
                    <Button
                        variant={option === "purchase" ? "contained" : "outlined"}
                        onClick={() => handleToggle("purchase")}
                    >
                        Purchase
                    </Button>
                    <Button
                        variant={option === "expense" ? "contained" : "outlined"}
                        onClick={() => handleToggle("expense")}
                    >
                        Expense
                    </Button>
                </div>

                {option === "purchase" && (
                    <>
                        <div className="table-filters flex flex-col md:flex-row items-start md:items-center justify-center md:justify-between mt-3 mb-">
                            <div className='text-2xl ml-2 font-bold font-poppins'>Purchase Reports</div>
                        </div>
                        <main className="m-5 p-5 xl:grid grid-cols-1 gap-10 xl:items-start">
                            <section>
                                <div className="bg-white p-5 rounded shadow">
                                    <div className="flex flex-col justify-center">
                                        <Button onClick={() => {
                                            setFromDate('')
                                            setFromDate('')
                                        }} variant="contained" disableElevation>
                                            Clear Filters
                                        </Button>
                                        <InputLabel>From Date</InputLabel>
                                        <FormControl>
                                            <input type="date" onChange={(e) => setFromDate(e.target.value)} />
                                        </FormControl>
                                        <InputLabel>To Date</InputLabel>
                                        <FormControl>
                                            <input type="date" onChange={(e) => setToDate(e.target.value)} />
                                        </FormControl>

                                        <InputLabel>Filter Category</InputLabel>
                                        <Select
                                            value={category}
                                            onChange={(selectedOption) => setCategory(selectedOption)}
                                            options = {categoryData}
                                            isClearable={true}
                                        />  

                                        <ReactToPrint
                                            trigger={() => (
                                                <button className="bg-green-500 mt-5 text-white font-bold py-2 px-4 rounded hover:bg-green-600 hover:text-white transition-all duration-150 hover:ring-4 hover:ring-green-400">
                                                    Generate Report
                                                </button>
                                            )}
                                            content={() => componentRef.current}
                                        />
                                    </div>
                                </div>
                            </section>

                            {/* Invoice Preview */}
                            <div className="invoice__preview bg-white p-5 rounded-2xl border-4 border-blue-200  ">
                                <ReactToPrint
                                    trigger={() => (
                                        <button className="bg-blue-500 ml-5 text-white font-bold py-2 px-8 rounded hover:bg-blue-600 hover:text-white transition-all duration-150 hover:ring-4 hover:ring-blue-400">
                                            Print / Download
                                        </button>
                                    )}
                                    content={() => componentRef.current}
                                />
                                <div
                                    ref={componentRef}
                                    className="py-5 px-8 flex flex-col min-h-full print:w-[210mm] print:h-[100mm] relative"
                                >
                                    <div className="flex flex-col items-center justify-center mb-5 xl:flex-row xl:justify-center w-full">
                                        <div>

                                            <img  src={companylogo} alt="logo" />
                                        </div>
                                    </div>
                                    <article className=" py-2 text-center text-base text-black border-t border-b border-black uppercase w-full font-bold">
                                        <p>Purchase Report</p>
                                    </article>

                                    <table width="100%" className="mb-10">
                                        <thead>
                                            <tr className=" text-center bg-gray-100 p-1 py-2 text-base text-black border-t border-b border-black uppercase w-full font-semibold">
                                                <td className="font-bold">Purchase Number</td>
                                                <td className="font-bold">Purchase Date</td>
                                                <td className="font-bold">Vendor</td>
                                                <td className="font-bold">Total</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredPurchases && filteredPurchases?.map((purchase) => (
                                                <tr key={purchase.id}>
                                                    <td>{purchase.purchase_number}</td>
                                                    <td>{(()=>{const temp = purchase.purchase_date
                                                            const date = new Date(temp)
                                                            return date.toLocaleDateString()
                                                    })()}</td>
                                                    <td>{purchase.vendor}</td>
                                                    <td>{purchase.total}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    <tr className=" text-center bg-gray-100 p-1 py-2 mb-10 text-center text-base text-black border-t border-b border-black uppercase w-full font-semibold" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <td className=" font-bold text-md text-center" colSpan={2}>
                                            Total Purchases: {calculateTotalPayments(filteredPurchases, "purchase")}
                                        </td>
                                    </tr>
                                    <tr className=" text-center h-10 font-bold mt-2">
                                        <td className=" font-bold text-lg border-t border-black text-center" colSpan={2}>
                                            Accountant
                                        </td>
                                    </tr>


                                </div>
                            </div>
                        </main>
                    </>
                )}

                {option === "expense" && (
                    <>
                        <div className="table-filters flex flex-col md:flex-row items-start md:items-center justify-center md:justify-between mt-3 mb-">
                            <div className='text-2xl ml-2 font-bold font-poppins'>Expense Reports</div>
                        </div>
                        <main className="m-5 p-5 xl:grid grid-cols-1 gap-10 xl:items-start">
                            <section>
                                <div className="bg-white p-5 rounded shadow">
                                    <div className="flex flex-col justify-center">
                                        <Button onClick={() => {
                                            setFromDate('')
                                            setFromDate('')
                                            setSearchQuery('')
                                        }} variant="contained" disableElevation>
                                            Clear Filters
                                        </Button>
                                        <InputLabel>From Date</InputLabel>
                                        <FormControl>
                                            <input type="date" onChange={(e) => setFromDate(e.target.value)} />
                                        </FormControl>
                                        <InputLabel>To Date</InputLabel>
                                        <FormControl>
                                            <input type="date" onChange={(e) => setToDate(e.target.value)} />
                                        </FormControl>
                                        <InputLabel>Search Expenses</InputLabel>
                                        <FormControl>
                                            <input 
                                                type="text" 
                                                value={searchQuery} 
                                                onChange={(e) => setSearchQuery(e.target.value)} 
                                                placeholder="Search expenses..."
                                            />
                                        </FormControl>
                                        

                                        <ReactToPrint
                                            trigger={() => (
                                                <button className="bg-green-500 mt-5 text-white font-bold py-2 px-4 rounded hover:bg-green-600 hover:text-white transition-all duration-150 hover:ring-4 hover:ring-green-400">
                                                    Generate Report
                                                </button>
                                            )}
                                            content={() => componentRef.current}
                                        />
                                    </div>
                                </div>
                            </section>

                            {/* Invoice Preview */}
                            <div className="invoice__preview bg-white p-5 rounded-2xl border-4 border-blue-200  ">
                                <ReactToPrint
                                    trigger={() => (
                                        <button className="bg-blue-500 ml-5 text-white font-bold py-2 px-8 rounded hover:bg-blue-600 hover:text-white transition-all duration-150 hover:ring-4 hover:ring-blue-400">
                                            Print / Download
                                        </button>
                                    )}
                                    content={() => componentRef.current}
                                />
                                <div
                                    ref={componentRef}
                                    className="py-5 px-8 flex flex-col min-h-full print:w-[210mm] print:h-[100mm] relative"
                                >
                                    <div className="flex flex-col items-center justify-center mb-5 xl:flex-row xl:justify-center w-full">
                                        <div>

                                            <img  src={companylogo} alt="logo" />
                                        </div>
                                    </div>
                                    <article className=" py-2 text-center text-base text-black border-t border-b border-black uppercase w-full font-bold">
                                        <p>Expense Report</p>
                                    </article>
                                    <table width="100%" className="mb-10">
                                        <thead>
                                            <tr className=" text-center bg-gray-100 p-1 py-2 text-base text-black border-t border-b border-black uppercase w-full font-semibold">
                                                <td className="font-bold">Expense ID</td>
                                                <td className="font-bold">Expense Title</td>
                                                <td className="font-bold">Amount</td>
                                                <td className="font-bold">Expense Date</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredExpenses && filteredExpenses?.map((expense) => (
                                                <tr key={expense.id}>
                                                    <td>{expense.id}</td>
                                                    <td>{expense.title}</td>
                                                    <td>{expense.amount}</td>
                                                    <td>{expense.expensedate}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    <tr className=" text-center bg-gray-100 p-1 py-2 mb-10 text-center text-base text-black border-t border-b border-black uppercase w-full font-semibold" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <td className=" font-bold text-md text-center" colSpan={2}>
                                            Total Payments: {calculateTotalPayments(filteredExpenses, "expense")}
                                        </td>
                                    </tr>
                                    <tr className=" text-center h-10 font-bold mt-2">
                                        <td className=" font-bold text-lg border-t border-black text-center" colSpan={2}>
                                            Accountant
                                        </td>
                                    </tr>
                                </div>
                            </div>
                        </main>
                    </>
                )}

            </div>
        </>
    )
}

export default PurchaseExpenseReportsPage
